import PrivacyTypeRadio from "./PrivacyTypeRadio";

export default PrivacyTypeRadio;
export { PrivacyTypeRadio };
